import {SET_PERMISSIONS, SET_SETTINGS} from "src/vuex/mutationTypes";
import collect from "collect.js";
import Setting from "src/models/settings";
// import TenantStatus from "@/utils/valueObjects/tenantStatus";
import _ from "lodash";
import i18n from "src/i18n";

const defaultState = {
  settings: {
    system:{
      theme: {}
    },
    permissions: null,
    role: null,
    plan: {},//@todo quando existirem planos diferentes
    features: [],
  },

};

const actions = {
  async fetchSettings({ dispatch, commit, getters, rootGetters }) {
    // getters.getSystemSettings !== undefined && !_.isEmpty(getters.getSystemSettings)
    //   ? rootGetters.getLoggedUser.permissions
    let settings = await Setting.findAll();
    commit(SET_SETTINGS, settings.data);
  },
  async updateSettings({ commit }, payload) {
    let setting = await Setting.update(payload);
    commit(SET_SETTINGS, [setting.data]);
  }
};

const mutations = {
  [SET_PERMISSIONS]: (state, permissions) => {
    state.settings.permissions = permissions;
  },
  [SET_SETTINGS]: (state, settings) => {
    // @todo adicionar outras configuracoes
    state.settings = settings;
  }
};

const getters = {
  getSettings: () => defaultState.settings,
  getPermissions: () => defaultState.settings.permissions,
  getRole: () => defaultState.settings.role,
  getPlans: () => defaultState.settings.plans,
  isSettingsLoaded: (state, getters) => {
    return getters.getSettings !== undefined && _.isEmpty(getters.getPermissions) === false ;
  },
  getSystemThemeClass: (state, getters) => {
    return getters.getSystemSettings.theme;
  },
  getCompanyFeatures: () => {
    return defaultState.settings.features
  },

};

export default {
  state: defaultState,
  getters,
  actions,
  mutations
};
